var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('span',[_vm._v(_vm._s(_vm.$t("page.footer.text1")))]),_c('img',{attrs:{"src":require("@/assets/ico-world.png")}}),_c('span',[_vm._v(_vm._s(_vm.$t("page.footer.text2")))])])}
var staticRenderFns = []

export { render, staticRenderFns }